import { apiClient } from "../../lib";
import { ControlledAutocompleteVariant } from "../components/ControlledAutocomplete";

export const controlledAutocomplete = {

    ENDPOINTS: {
        PROJECT: "/projects/search",
        PORTFOLIO: "/portfolios/search",
        PROGRAMME: "/programme/search",
        SEARCH_PORTFOLIO_PROJECTS : "/projects/search-portfolio-projects",
    },

    get: async ({
        type,
        search_term,
        programme_id,
        portfolio_id,
    }: {
        type: ControlledAutocompleteVariant;
        search_term?: string;
        programme_id?: string;
        portfolio_id?: string;
    }): Promise<any> => {
        const params = new URLSearchParams();
        if (search_term) params.append("search_term", search_term);
        if (programme_id) params.append("programme_id", programme_id);
        if (portfolio_id) params.append("portfolio_id", portfolio_id);
        const endpoint = controlledAutocomplete.ENDPOINTS[type];
        const response = await apiClient.get(params ? `${endpoint}?${params}` : endpoint);
        return response.data.data;
    }

};